import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import CSSZSickLeaveCertificateReturnAdmissionRequest from './CSSZSickLeaveCertificateReturnAdmissionRequest';
import { CSSZSickLeaveCertificate } from '../../Interfaces/CSSZ.interface';

interface Props extends BaseModalProps {
	item: CSSZSickLeaveCertificate;
	patientId: string;
	onCreate: (jobId?: string) => void;
}

const CSSZSickLeaveCertificateReturnAdmissionRequestModal: React.FC<
	Props
> = props => {
	return (
		<BaseModal
			{...props}
			title='component.CSSZSickLeaveCertificateReturnAdmissionRequest.modalTitle'>
			<CSSZSickLeaveCertificateReturnAdmissionRequest
				item={props.item}
				patientId={props.patientId}
				onCreate={props.onCreate}
			/>
		</BaseModal>
	);
};

export default CSSZSickLeaveCertificateReturnAdmissionRequestModal;
